module.exports = __webpack_public_path__ + "static/media/user.aac8506f.svg";